import React, { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import message from 'antd/lib/message';
import Popconfirm from 'antd/lib/popconfirm';
import Spin from 'antd/lib/spin';

import SecureTransactionComponent from './secure_transaction_component'
import ModalComponent from './modal_component'
import AuthenticationService from '../../../service/authentication_service';

import AppService from '../../../service/app_service';

class TopBarComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            dashboard: props.dashboard,
            showNav: false,
            showModal: false,
            showUserMenu: false,
            showMobileSubMenu:false,
            amount: 1,
            rate: 1,
            role: 'seller',
            loading: false,
        };
    }

    componentDidMount() {
        if (!AuthenticationService.getToken()) {
            this.props.history.push("/");
            message.error('Kindly login');
        }
    }
    logout = () => {
        AuthenticationService.clearLocalstorage();
        this.props.history.push("/signin");
    }
    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

    }

    postSellRequest = () => {
        if (!AuthenticationService.getToken()) {
            message.error("Kindly login first.")
        }
        else if (this.state.amount && this.state.description && this.state.role && this.state.asset && this.state.partnerMobileNumber) {
            this.setState({
                loading: true, responseMessage: ''
            });
            let data = {};
            data.asset = this.state.asset;
            data.name = this.state.asset;
            data.description = this.state.description;
            data.amount = parseFloat(this.state.amount.replace(/,/g, ''));
            data.role = this.state.role;
            data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
            data.partnerMobileNumber = this.state.partnerMobileNumber;
            data.partnerEmailAddress = this.state.partnerEmailAddress;
            data.myEmailAddress = AuthenticationService.getEmail();
            data.type = "TRANSACTION";
            AppService.postSellRequest(data).then(rec => {

                if (rec.code) {
                    message.error(rec.description)
                } else {
                    this.setState({
                        coins: rec.data, amount: 0, rate: 1, description: '', asset: '', loading: false, partnerMobileNumber: '', responseMessage: rec.description
                    });
                    message.success("Transaction uploaded successfully")
                    this.props.history.push("/transaction/detail/" + rec.ref)
                    //this.getOrders();
                }

            })
        } else {
            if (!this.state.amount) {
                message.error('Amount is missing')
            } else if (!this.state.description) {
                message.error('Description is missing')
            } else if (!this.state.role) {
                message.error('Role is missing')
            } else if (!this.state.asset) {
                message.error('Product name is missing')
            } else if (!this.state.partnerMobileNumber) {
                message.error('Phone number is missing')
            }


        }

    }
    render() {
        const { showNav, showModal, showUserMenu, role, responseMessage, loading,showMobileSubMenu } = this.state;
        return (
            <div className="topbar-wrap">
                <div className="topbar is-sticky">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <ul className="topbar-nav d-lg-none">
                                <li className="topbar-nav-item relative">
                                    <a className={"toggle-nav " + (showNav ? "active" : "")} onClick={() => this.setState({ showNav: !this.state.showNav })}>
                                        <div className="toggle-icon"><span className="toggle-line" /><span className="toggle-line" /><span className="toggle-line" /><span className="toggle-line" /></div>
                                    </a>
                                </li>
                                {/* .topbar-nav-item */}
                            </ul>
                            {/* .topbar-nav */}<a className="topbar-logo" href="/"><img src="/assets/images/logo.png" srcSet="/assets/images/logo.png 2x" alt="logo" /></a>
                            <ul className="topbar-nav">
                                {AuthenticationService.getToken() && <li className="topbar-nav-item relative">
                                    <span className="user-welcome d-none d-lg-inline-block">Welcome! {AuthenticationService.getName()}</span>
                                    <img className={"toggle-tigger user-thumb " + (showUserMenu ? "active" : "")} src={AuthenticationService.getImage()} onClick={() => this.setState({ showUserMenu: !this.state.showUserMenu })} />
                                    <div className={"toggle-class dropdown-content dropdown-content-right dropdown-arrow-right user-dropdown " + (showUserMenu ? "active" : "")}>
                                        {/* <div className="user-status">
                                            <h6 className="user-status-title">Balance</h6>
                                            <div className="user-status-balance">**,***,*** <small>***</small></div>
                                        </div> */}
                                        <ul className="user-links">
                                            <li><Link to="/profile" ><i className="ti ti-id-badge" />Profile</Link></li>
                                        </ul>
                                        <ul className="user-links bg-light">
                                            <li><a onClick={() => this.logout()}><i className="ti ti-power-off" />Logout</a></li>
                                        </ul>
                                    </div>
                                </li>}
                                {/* .topbar-nav-item */}
                            </ul>
                            {/* .topbar-nav */}
                        </div>
                    </div>
                    {/* .container */}
                </div>
                {/* .topbar */}
                <div className={"navbar " + (window.innerWidth < 982 ? "navbar-mobile" : "") + (showNav ? " active" : "")}>
                    <div className="container">
                        <div className="navbar-innr">
                            {<ul className="navbar-menu">
                                {AuthenticationService.getToken() && <li className={" " + (this.props.location.pathname === "/dashboard" ? "active" : "")}><Link to="/dashboard"><em className="ikon ikon-dashboard" /> Dashboard</Link></li>}
                                {/* <li className={" " + (this.props.location.pathname === "/transactions" ? "active" : "")}><Link to="/transactions" ><em className="ikon ikon-transactions" /> Escrow</Link></li> */}
                                <li className={" " + (this.props.location.pathname === "/giveaway/detail/ALL" ? "active" : "")}><Link to="/giveaway/detail/ALL" ><em className="ikon ikon-transactions" /> Giveaways</Link></li>
                                <li className={" " + (this.props.location.pathname === "/airtime/disbursement" ? "active" : "")}><Link to="/airtime/disbursement" ><em className="ikon ikon-transactions" /> Airtime Disbursement</Link></li>
                                {/* <li className={" " + (this.props.location.pathname === "/evoting" ? "active" : "")}><Link to="/evoting" ><em className="ikon ikon-transactions" /> Evoting</Link></li> */}
                                {AuthenticationService.getToken() && <li className={" " + (this.props.location.pathname === "/profile" ? "active" : "")}><Link to="/profile"><em className="ikon ikon-user" /> Profile</Link></li>}

                            </ul>}
                            {!AuthenticationService.getToken() && <ul className="navbar-menu">
                                <li className={" " + (this.props.location.pathname === "/signin" ? "active" : "")}><Link to="/signin" ><em className="ikon ikon-user" /> Login</Link></li>
                            </ul>}
                            {AuthenticationService.getToken() && <ul className="navbar-btns">
                                {/* <li><SecureTransactionComponent /></li> */}
                                <li className="d-none"><span className="badge badge-outline badge-success badge-lg"><em className="text-success ti ti-files mgr-1x" /><span className="text-success">KYC Approved</span></span></li>
                            </ul>}
                        </div>
                        {/* .navbar-innr */}
                    </div>
                    {/* .container */}
                </div>
                {/* .navbar */}

                {showModal && <ModalComponent show={showModal} closeModal={() => this.setState({ showModal: !this.state.showModal })} title="Secucure A Transaction" >
                    <div>

                        <Spin spinning={loading}>
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Amount</label>
                                        <input type="number" name="amount" className="input-bordered" placeholder="Amount" onChange={this.handleChange} />
                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">I'm</label>
                                        <div className="select-wrapper">
                                            <select name="role" className="input-bordered" value={role} onChange={this.handleChange}>
                                                <option value="seller">Selling (Seller)</option>
                                                <option value="buyer">Buying (Buyer)</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Asset</label>
                                        <input type="text" name="asset" value={this.state.asset} className="input-bordered" placeholder="" onChange={this.handleChange} />
                                    </div>






                                    {/* <div className="input-item input-with-label">
                                <label className="input-item-label">File Upload</label>
                                <div className="relative">
                                    <em className="input-file-icon fas fa-upload" />
                                    <input type="file" className="input-file" id="file-01" />
                                    <label htmlFor="file-01">Choose a file</label>
                                </div>
                            </div> */}
                                </div>
                                <div className="col-md-6">
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">{role === "seller" ? "Buyer's" : "Seller's"} phone number</label>
                                        <input type="phone" name="partnerMobileNumber" value={this.state.partnerMobileNumber} className="input-bordered" placeholder="Phone number" onChange={this.handleChange} />

                                    </div>

                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">{role === "seller" ? "Buyer's" : "Seller's"} email address</label>
                                        <input type="phone" name="partnerEmailAddress" value={this.state.partnerEmailAddress} className="input-bordered" placeholder="Email address" onChange={this.handleChange} />

                                    </div>
                                    <div className="input-item input-with-label">
                                        <label className="input-item-label">Terms</label>
                                        <textarea type="text" name="description" value={this.state.description} className="input-bordered" placeholder="" onChange={this.handleChange} />
                                    </div>

                                </div>
                                <div className="col-md-12">
                                    <p>{(responseMessage)}</p>
                                    {<Popconfirm
                                        title="Are you sure to submit this transaction?"
                                        onConfirm={this.postSellRequest}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <button type="submit" disabled={loading} name="submit" className="btn btn-success btn-block">Safeguard this transaction</button>
                                    </Popconfirm>}
                                </div>

                            </div>
                        </Spin>




                    </div>
                </ModalComponent>}
            </div>
        );
    }
}

export default withRouter(TopBarComponent);
